import script from "./TradePassportReviews.vue?vue&type=script&setup=true&lang=ts"
export * from "./TradePassportReviews.vue?vue&type=script&setup=true&lang=ts"

import "./TradePassportReviews.vue?vue&type=style&index=0&id=21cd9392&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21cd9392"]])

export default __exports__